<template>
  <div class="order-step">
    <!-- <img src="@/assets/tms/step_icon.png" /> -->
    <div
      class="order-step-item"
      v-for="(item, index) in statuList"
      :key="index"
    >
      <div class="satus-name">
        <p :class="[item.IsActive ? 'name': 'grey-name']">{{ item.MilestoneDesc }}</p>
        <div v-show="index < 3" class="flex" style="margin-left: 36px">
          <!-- <div
            class="circular-ring"
            :style="{
              border: item.IsActive ? '2px solid #59b9d3' : '2px solid #E9ECF2',
            }"
          ></div> -->
          <div
            style="width: 90px;border-top:2px dashed;margin-top: 6px;"
            :style="{borderColor: item.IsActive ? '#59b9d3' : '#E9ECF2' }"
          ></div>
          <i class="el-icon-caret-right" :style="{color: item.IsActive ? '#59b9d3' : '#E9ECF2'}"></i>
          <!-- <div
            class="circular-ring"
            :style="{
              border: item.IsActive ? '2px solid #59b9d3' : '2px solid #E9ECF2',
            }"
          ></div> -->
        </div>
      </div>
      <div class="status-time">{{ item.EventDT }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    statuList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less">
.order-step {
  display: flex;
  img {
    width: 34px;
    height: 34px;
    display: inline-block;
    margin-right: 8px;
  }
  .order-step-item {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .satus-name {
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 12px;
      font-weight: 600;
      color: #111827;
    }
    .grey-name {
      font-size: 12px;
      font-weight: 600;
      color: #9ca3af;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
    }
  }
  .status-time {
    font-size: 10px;
    font-weight: 500;
    color: #9ca3af;
    line-height: 14px;
  }
}
</style>
